import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HTTPService } from 'app/services/http.service';
import { HelperService } from 'app/services/helper.service';

@Component({
  selector: 'app-rename-attachment-dialog',
  templateUrl: './rename-attachment-dialog.component.html',
  styleUrls: ['./rename-attachment-dialog.component.scss'],
})
export class RenameAttachmentDialogComponent implements OnInit {
  attachment: any = {
    fileExtension: '',
    title: '',
    _id: '',
  };

  titleKey = 'title';

  constructor(public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig, private httpService: HTTPService, private helperService: HelperService) {}

  ngOnInit() {
    const {
      attachment = {
        fileExtension: '',
        title: '',
        _id: '',
      },
    } = this.dialogConfig.data || {};
    this.attachment._id = attachment._id;
    this.attachment.fileExtension = attachment.fileExtension;
    this.attachment.title = attachment.title;
  }

  handleChange(value, key) {
    this.attachment[key] = value;
  }

  save() {
    try {
      this.httpService
        .updateEstimateAttachment(this.attachment._id, {
          title: this.attachment.title,
        })
        .then(
          (res) => {
            this.helperService.showToaster('success', 'Updated Successfully');
            this.closeDialog({ isSuccess: true });
          },
          (err) => {
            this.helperService.showToaster('error', err);
          }
        );
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  closeDialog(data: any) {
    this.ref.close(data);
  }
}
